(async () => {

  if (!customElements.get('product-media-slider')) {

    // Import Swiper core and modules correctly for v11
    const Swiper = (await import('swiper')).default;
    const { Navigation, Pagination, Scrollbar, Autoplay, Mousewheel } = await import('swiper/modules');
    const { Fancybox } = await import("@fancyapps/ui");

    class ProductMediaSlider extends HTMLElement {
      constructor() {
        super();

        // Create elements
        this.mainSlider();
        this.fancybox();

        // Reduce actions (So the event can also be removed)
        this.reducer = {
          slideToVariant: (e) => this.slideToVariant(e),
        }

        // Listen for variant change and go to slide
        document.addEventListener('variant-change', this.reducer.slideToVariant);
      }

      /*
      * Create main slider
      */
      mainSlider() {
        // Check if Swiper exists
        if (typeof Swiper == 'undefined') {
          return false;
        }

        // Get swiper element
        this.swiperMain = this.querySelector('[data-product-media-slider]');

        // Get initial slide and swiper index
        let initialSlideIndex = 0;
        const initalVariant = parseInt(this.swiperMain.dataset.productMediaSlider);
        if (initalVariant) {
          const initialSlide = this.matchVariantIdWithSlide(initalVariant);
          initialSlideIndex = initialSlide ? initialSlide : initialSlideIndex;
        }

        // Swiper options
        this.swiperMainOptions = {
          modules: [Navigation, Pagination, Scrollbar, Autoplay, Mousewheel],
          direction: 'horizontal',
          slidesPerView: 1,
          spaceBetween: 16,
          threshold: 10,
          allowTouchMove: true,
          loop: true,
          initialSlide: initialSlideIndex,
          mousewheel: true,
          navigation: {
            nextEl: '.swiper-button-main-next',
            prevEl: '.swiper-button-main-prev'
          }
        };

        // Create Main slider
        this.swiperMainInstance = new Swiper(this.swiperMain, this.swiperMainOptions);

        // Rebuid Swiper in design mode
        if(Shopify.designMode && this.swiperMainInstance) {
          window.addEventListener('shopify:section:load', () => {
            this.swiperMainInstance.update();
          });
        }

        // Bug fix for Chrome lazy loading images within a slider with direction rtl
        // Change lazy loading from true to eager on slide change
        this.swiperMainInstance.on('slideChange', () => {
          this.swiperMainInstance.activeIndex;

          const slidesCount = this.swiperMainInstance.slides.length;
          const nextSlide = this.swiperMainInstance.activeIndex + 1;

          if (nextSlide < slidesCount ) {
            const slide = this.querySelector(`[data-slide="${this.swiperMainInstance.activeIndex + 1}"]`);
            const image = slide.querySelector('img');
            const iframe = slide.querySelector('iframe');

            if (image && image.getAttribute('loading') == 'lazy') {
              image.setAttribute('loading', 'eager')
            }

            if (iframe && iframe.getAttribute('loading') == 'lazy') {
              iframe.setAttribute('loading', 'eager')
            }
          }
        });
      }

      /*
      * Create fancybox
      */
      fancybox() {

        // Check if Fancybox exists
        if (typeof Swiper == 'undefined') {
          return false;
        }

        Fancybox.bind("[data-fancybox]", {
          animated: false,
          showClass: false
        });

      }

      /*
      * Slide to variant
      * @Param e {object}: event object with variant
      */
      slideToVariant(e) {
        if (e?.detail?.variant?.id) {
          const slideIndex = this.matchVariantIdWithSlide(e.detail.variant.id);
          if (typeof slideIndex == 'number') {
            this.goToSlide(slideIndex);
          }
        }
      }

      /*
      * Match variant id with slide
      * @param id {int}: variant id
      */
      matchVariantIdWithSlide(id) {
        if (!id || !this.swiperMain) {
          return false;
        }

        // Get slides
        const slides = this.swiperMain.querySelectorAll('[data-product-variant-image]');

        // Match id with slides id's
        const slide = [...slides].find((slide) => {

          // Get variant id's attached to slide
          const slideVariants = JSON.parse(slide.dataset.productVariantImage);

          // Check if variant id match the slide variant id's
          if (slideVariants.includes(id)) {
            return slide;
          }

        });

        // return false if no slide found
        if (!slide) {
          return false;
        }

        // return matched slide index
        return getNodeIndex(slide)
      }

      /*
      * go to slide
      * @param slide {node} / {int}: slide node / index
      */
      goToSlide(slide) {
        if (
          (typeof slide != 'number' && typeof slide != 'object') ||
          !this.swiperMainInstance
        ) {
          return false;
        }

        // Get index, transform node to slide index or string to int
        const index = typeof slide == 'number' ? parseInt(slide) : getNodeIndex(slide);

        // go to slide
        this.swiperMainInstance.slideTo(index);
      }
    }
    window.ProductMediaSlider = ProductMediaSlider;
    customElements.define('product-media-slider', ProductMediaSlider);
  }
})();
